import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=587cd4ae&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=587cd4ae&prod&lang=less"
import style1 from "./Register.vue?vue&type=style&index=1&id=587cd4ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587cd4ae",
  null
  
)

export default component.exports